import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import DropzoneUpload from './components/DropzoneUpload';
import DropzonePreview from './components/DropzonePreview';
import DropzoneProgress from './components/DropzoneProgress';

import './styles.css';

export const SMALL = 'small';
export const LARGE = 'large';

export const DEFAULT = LARGE;

export const DEFAULT_TYPE_CLASS = LARGE;
export const DROPZONE_TYPE_CLASS = {
  [DEFAULT]: LARGE,
  [LARGE]: LARGE,
  [SMALL]: SMALL
};

const Dropzone = ({
  onDrop,
  multiple,
  files,
  uploading,
  wrongFormat,
  removeFile,
  acceptedFileTypes,
  defaultComponent,
  disableClick,
  onDrag,
  disablePreview,
  type
}: any) => {
  const isFileUploaded = !_.isEmpty(files);
  const showUpload = !isFileUploaded && !uploading;
  const showPreview = !disablePreview && isFileUploaded && !uploading;

  return (
    <div className={classNames('DropzoneContainer', {defaultComponent})}>
      {showUpload && (
        <DropzoneUpload
          onDrop={onDrop}
          onDrag={onDrag}
          multiple={multiple}
          wrongFormat={wrongFormat}
          acceptedFileTypes={acceptedFileTypes}
          defaultComponent={defaultComponent}
          disableClick={disableClick}
        />
      )}
      {uploading && <DropzoneProgress />}
      {showPreview && (
        <DropzonePreview file={files[0]} removeFile={removeFile} type={type} />
      )}
    </div>
  );
};

Dropzone.LARGE = LARGE;
Dropzone.SMALL = SMALL;

export default Dropzone;
